import { render, staticRenderFns } from "./TicketsListModal.vue?vue&type=template&id=97587d80&"
import script from "./TicketsListModal.vue?vue&type=script&lang=js&"
export * from "./TicketsListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports